export enum WalletType {
  ReadOnly = 'readonly',
  Signer = 'casper-signer',
  CasperWallet = 'casper-wallet',
  CasperDash = 'casperdash',
  MetamaskSnap = 'metamask-snap',
  Ledger = 'ledger',
}
